import axios from "@/features/axiosHelper";
import EnvironmentSelectionPane from "@/components/Login/EnvironmentSelectionPane";
import LoadingBar from "@/components/shared/LoadingBar";
import VersionInfo from "@/components/Login/VersionInfo";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectSignInState } from "@/features/auth/authSlice";

import {
  Box,
  Container,
} from "@mui/material";

import {
  ShepTextLogo,
} from "../../ImageRepo";

const ExternalLogin = () => {
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const isSignedIn = useSelector(selectSignInState);
  const [tenantList, setTenantList] = useState();
  const [popupEnabled, setPopupEnabled] = useState(false);
  const [termsChallenge, setTermsChallenge] = useState(null);

  useEffect(() => {
    if (isSignedIn) {
      navigate(queryParameters.get("returnUrl") ?? "/homepage");
    }
  }, [isSignedIn, navigate]);

  useEffect(() => {
    if (tenantList) {
      return; // Already populated
    }

    // Populate tenant list
    axios
      .get("/login/users/external-callback", {
        params: queryParameters,
      })
      .then((res) => {
        localStorage.setItem("refreshToken", res.data.refreshToken ?? "");
        setTenantList(res.data.tenants);

        if (res.data.termsRequired) {
          localStorage.setItem("pendingToken", res.data.pendingToken);
          setTermsChallenge({
            termsRequired: true,
            termsConditionId: res.data.termsConditionId,
            htmlContent: res.data.htmlContent,
          });
          // refreshToken is not issued until terms are accepted; clear any stale value
          localStorage.removeItem("refreshToken");
        }

        window.heap.track("Login - Success", { "Method": "Single Sign-On" });
      })
      .catch((err) => {
        // Something went wrong or user closed selection popup and request failed
        console.error(err);
        navigate("/");
      });
  });

  return popupEnabled ? (
    <Container
      className="login-container"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        padding: "30px",
        backgroundColor: "var(--text-primary)",
        overflow: "hidden",
      }}
    >
      <Box
        className="login-left-container"
        sx={{
          width: "50vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="login-container-contents">
          <img src={ShepTextLogo} alt="Shep Logo" className="shepTextLogo" />
          <VersionInfo />
        </div>
      </Box>

      <Box
        className="login-right-container"
        sx={{
          width: "50vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="loginContent">
          <EnvironmentSelectionPane tenantGroup={tenantList} initialTermsChallenge={termsChallenge} />
        </div>
      </Box>
    </Container>
  ) : (
    <Container
      className="login-container"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        padding: "30px",
        backgroundColor: "var(--text-primary)",
        overflow: "hidden",
      }}
    >
      <Box
        className="login-left-container"
        sx={{
          width: "50vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="login-container-contents">
          <img src={ShepTextLogo} alt="Shep Logo" className="shepTextLogo" />
          <VersionInfo />
        </div>
      </Box>

      <Box
        className="login-right-container"
        sx={{
          width: "50vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="loginContent">
          <LoadingBar
            isDarkMode={true}
            isDataLoaded={tenantList}
            setFinishedAnimation={setPopupEnabled}
          />
        </div>
      </Box>
    </Container>
  );
};
export default ExternalLogin;
